// Core packages
import { NgModule } from "@angular/core";

// Third party packages

// Custom packages - Modules
import { SharedModule } from "src/app/modules/shared.module";

// Custom packages - Components
import { CompanySearchComponent } from "src/app/modules/search-docs/components/company-search/company-search.component";
import { SupplierSearchComponent } from "src/app/modules/search-docs/components/supplier-search/supplier-search.component";

/**
 * The company and supplier filters of the general document search, as a unit of their own.
 *
 * A module apart because two pages use them: the legacy search (`listv2`, in SearchDocsModule) and the
 * search on the 3.0.0 archive (`listv3`, in its lazy SearchDocsListV3Module). Declared in
 * SearchDocsModule they could reach the second page only by importing SearchDocsModule, routes
 * included.
 *
 * @since 3.0.0
 */
@NgModule({
  imports: [SharedModule],
  declarations: [CompanySearchComponent, SupplierSearchComponent],
  exports: [CompanySearchComponent, SupplierSearchComponent],
})
export class SearchDocsFiltersModule {}
